import React from "react";
import SubmitPostButton from "./posts/SubmitPostButton";
import {
  home,
  explore,
  twitter,
  notifications,
  messages,
  bookmarks,
  lists,
  profile,
  more,
} from "./posts/icons";
import "./Navbar.scss";

const Navbar = (props) => {
  return (
    <div className="top-pane">
      <div className="container">
        <header>{twitter}</header>
        <header>{home} Home</header>
        <header>{explore} Explore</header>
        <header>{twitter} Twitter</header>
        <header>{notifications} Notifications</header>
        <header>{messages} Messages</header>
        <header>{bookmarks} Bookmarks</header>
        <header>{lists} Lists</header>
        <header>{profile} Profile</header>
        <header>{more} More</header>
        <SubmitPostButton setModalOpen={props.setModalOpen} />
      </div>
    </div>
  );
};

export default Navbar;
